import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useFirstDepositBonus } from '../hooks/useFirstDepositBonus';
import Icon from './Icon';

const POPUP_KEY = 'first_deposit_bonus_popup_seen';

/**
 * One-time welcome popup nudging the player toward their first deposit. Shows
 * once per browser for an eligible player; the confirm CTA routes to the wallet
 * top-up page.
 */
export default function FirstDepositBonusPopup() {
  const { data } = useFirstDepositBonus();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!data?.eligible || data.percent <= 0) return;
    let seen = false;
    try { seen = localStorage.getItem(POPUP_KEY) === '1'; } catch { /* ignore */ }
    if (!seen) setVisible(true);
  }, [data?.eligible, data?.percent]);

  const close = () => {
    try { localStorage.setItem(POPUP_KEY, '1'); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible || !data || !data.eligible || data.percent <= 0) return null;
  const percent = data.percent;

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        backgroundColor: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 28,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 380, borderRadius: 22, padding: 28,
          backgroundColor: colors.card, border: `1px solid ${colors.cardBorder}`,
          display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 76, height: 76, borderRadius: 38, marginBottom: 18,
            backgroundColor: colors.accentSoft,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <Icon name="gift" size={34} color={colors.accentText} />
        </div>
        <div style={{ fontSize: 21, fontWeight: 900, color: colors.text, marginBottom: 10 }}>
          {t('firstDepositBonus.popupTitle', { percent })}
        </div>
        <div style={{ fontSize: 14, lineHeight: 1.5, color: colors.textSub, marginBottom: 24 }}>
          {t('firstDepositBonus.popupBody', { percent })}
        </div>
        <button
          onClick={() => { close(); navigate('/wallet-topup'); }}
          style={{
            width: '100%', minHeight: 50, borderRadius: 999, border: 'none', cursor: 'pointer',
            backgroundColor: colors.accent, color: '#020617', fontSize: 15, fontWeight: 800,
          }}
        >
          {t('firstDepositBonus.popupConfirm')}
        </button>
        <button
          onClick={close}
          style={{
            marginTop: 12, padding: '8px 16px', background: 'transparent', border: 'none',
            cursor: 'pointer', fontSize: 13, fontWeight: 600, color: colors.textSub,
          }}
        >
          {t('firstDepositBonus.popupDismiss')}
        </button>
      </div>
    </div>
  );
}
